import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";
import { DELIVERY_INDEX } from "@/data/site";

export const DeliveryRadar = () => (
  <div className="h-[340px] w-full sm:h-[420px]" data-testid="delivery-radar">
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart data={DELIVERY_INDEX} outerRadius="72%">
        <PolarGrid stroke="rgba(255,255,255,0.12)" />
        <PolarAngleAxis
          dataKey="dimension"
          tick={{ fill: "#8A8F98", fontSize: 11, fontFamily: "JetBrains Mono" }}
        />
        <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
        <Radar
          dataKey="value"
          stroke="#D6FF00"
          fill="#008753"
          fillOpacity={0.35}
          strokeWidth={1.5}
          isAnimationActive
          animationDuration={1400}
          dot={{ r: 3, fill: "#D6FF00", stroke: "none" }}
        />
      </RadarChart>
    </ResponsiveContainer>
  </div>
);
